import { featureType } from "../../features/manageRole/ManageRoleRegistry";
import { Action, configurationAttributeType } from "../../types";

export interface portalConfig{
    featureConfig: featureType[],
    layoutConfig: configurationAttributeType<any[]>[],
    roleOrderLayout: configurationAttributeType<any[]>[]
}
const initialState: portalConfig | null = null;
export function portalConfigReducer(state: portalConfig | null = initialState, action: Action<portalConfig | null>): portalConfig | null{
    switch(action.type){
        case "setPortalConfig": {
            return action.payload
        }
        default: {
            return state;
        }
    }
}